<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">{{ sourceList.meeting_info.name }}</div>
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">申请信息</div>
                    </div>
                    <div class="line"></div>
                    <div class="lk">
                        <label>会议室名称：</label>
                        <input
                            type="text"
                            :value="sourceList.meeting_info.name"
                            disabled
                        />
                    </div>
                    <div class="lk">
                        <label>预约人：</label>
                        <input
                            type="text"
                            placeholder="请输入姓名"
                            v-model="name"
                            disabled
                        />
                    </div>
                    <div class="lk">
                        <label>联系方式：</label>
                        <input
                            type="text"
                            placeholder="请输入电话"
                            v-model="mobile"
                            disabled
                        />
                    </div>
                    <div class="lk">
                        <label>预约主题：</label>
                        <input
                            type="text"
                            placeholder="请输入预约主题"
                            v-model="object"
                        />
                    </div>
                    <div class="lk speak">
                        <label>预约说明：</label>
                        <textarea
                            placeholder="请输入预约说明"
                            v-model="speak"
                        ></textarea>
                    </div>
                    <div style="height:100px;"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">在线预约</div>
                    </div>
                    <div class="line"></div>

                    <!-- 选择插件 -->
                    <div style="height:32px"></div>
                    <month
                        @findTime="findTime"
                        :apply="apply"
                        @all="all"
                    ></month>
                    <div style="height:42px;"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">温馨提示</div>
                    </div>
                    <div class="line"></div>

                    <div class="zhushi">
                        注：每个小块15分钟，蓝色表示已被预约，黄色表示审批中，绿色表示用户选择。
                    </div>
                    <div class="replay">
                        <div class="left" @click="applys">提交</div>
                        <div class="right" @click="goback">取消</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "room_appointmentApply",
    data() {
        return {
            value: "",
            currentPage: 10,
            show: false,
            time: "",
            sourceList: {
                meeting_info: {}
            },
            apply: {},
            name: localStorage.getItem("username"),
            mobile: localStorage.getItem("mobile"),
            object: "",
            speak: "",
            allStartTime: "",
            allEndTime: ""
        };
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        all(data) {
            this.allStartTime = data.allStartTime;
            this.allEndTime = data.allEndTime;
        },
        applys() {
            if (this.object == "") {
                this.$toast("预约主题不能为空");
                return;
            }
            if (this.speak == "") {
                this.$toast("预约说明不能为空");
                return;
            }
            if (this.allStartTime == "") {
                this.$toast("开始时间不能为空");
                return;
            }
            if (this.allEndTime == "") {
                this.$toast("结束时间不能为空");
                return;
            }
            let params = {
                type_id: this.$route.query.id,
                user_phone: this.mobile,
                theme: this.object,
                explain: this.speak,
                start_time: this.allStartTime,
                end_time: this.allEndTime
            };
            let _this = this;
            _this
                .$confirm("确定要对当前数据进行提交吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消"
                })
                .then(() => {
                    _this
                        .$post("/api/Order/save_meeting_appointment", params)
                        .then(res => {
                            if (res.code == 1) {
                                _this.$toast(res.msg);
                                setTimeout(() => {
                                    _this.$router.replace("/room_appointment");
                                }, 1500);
                            } else {
                                _this.$toast(res.msg);
                            }
                        })
                        .catch(err => {
                            console.log(err);
                        });
                })
                .catch(() => {});
        },
        details() {
            let params = {
                time: this.time,
                id: this.$route.query.id
            };
            this.$post("/api/Meeting/meeting_info", params)
                .then(res => {
                    if ((res.code = 1)) {
                        let data = [],
                            data2 = [],
                            data3 = [],
                            data4 = [],
                            index = "",
                            index2 = "",
                            index3 = "",
                            index4 = "";
                        for (var i = 0; i < 24; i++) {
                            if (i < 10) {
                                index = "0" + i + ":15";
                                index2 = "0" + i + ":30";
                                index3 = "0" + i + ":45";
                                index4 = "0" + i + ":00";
                            } else {
                                index = i + ":15";
                                index2 = i + ":30";
                                index3 = i + ":45";
                                index4 = i + ":00";
                            }
                            data[i] = { time: index, type: 1, status: false };
                            data2[i] = { time: index2, type: 1, status: false };
                            data3[i] = { time: index3, type: 1, status: false };
                            data4[i] = { time: index4, type: 1, status: false };
                        }
                        var date = new Date();
                        var timestamp = date.valueOf(); //当前的时间戳
                        var y = date.getFullYear();
                        var m = date.getMonth() + 1;
                        m = m < 10 ? "0" + m : m;
                        var d = date.getDate();
                        d = d < 10 ? "0" + d : d;
                        var toTime = y + "-" + m + "-" + d; //当天的日期
                        console.log(
                            "1111=>",
                            this.time == "" ? toTime : this.time
                        );
                        console.log("todday:", timestamp);
                        for (var i in data) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (res.data.time[k].time == data[i].time) {
                                        data[i].type = 2; //审批中
                                    }
                                } else {
                                    if (res.data.time[k].time == data[i].time) {
                                        data[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data[i].status = true;
                            }
                        }
                        for (var i in data2) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (
                                        res.data.time[k].time == data2[i].time
                                    ) {
                                        data2[i].type = 2; //审批中
                                    }
                                } else {
                                    if (
                                        res.data.time[k].time == data2[i].time
                                    ) {
                                        data2[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data2[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data2[i].status = true;
                            }
                        }
                        for (var i in data3) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (
                                        res.data.time[k].time == data3[i].time
                                    ) {
                                        data3[i].type = 2; //审批中
                                    }
                                } else {
                                    if (
                                        res.data.time[k].time == data3[i].time
                                    ) {
                                        data3[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data3[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data3[i].status = true;
                            }
                        }
                        for (var i in data4) {
                            for (var k in res.data.time) {
                                if (res.data.time[k].type == 1) {
                                    if (
                                        res.data.time[k].time == data4[i].time
                                    ) {
                                        data4[i].type = 2; //审批中
                                    }
                                } else {
                                    if (
                                        res.data.time[k].time == data4[i].time
                                    ) {
                                        data4[i].type = 3; //被预约
                                    }
                                }
                            }
                            let timeday = this.time == "" ? toTime : this.time;
                            let dat = new Date(
                                timeday + " " + data4[i].time
                            ).getTime();
                            if (timestamp > dat) {
                                data4[i].status = true;
                            }
                        }
                        let result = {
                            data: data,
                            data2: data2,
                            data3: data3,
                            data4: data4
                        };
                        console.log(result);
                        this.sourceList = res.data;
                        this.apply = result;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        findTime(e) {
            this.time = e;
            this.details();
        }
    },
    mounted() {
        this.details();
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
        }
        .details {
            width: 838px;
            height: auto;
            background: #ffffff;
            margin-top: 21px;
            .title {
                display: flex;
                height: 43px;
                align-items: center;
                .ricle {
                    width: 4px;
                    height: 4px;
                    background: #ffffff;
                    border: 3px solid #3449d3;
                    border-radius: 50%;
                    margin-left: 20px;
                }
                .txt {
                    font-size: 18px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    padding-left: 14px;
                }
            }
            .line {
                width: 793px;
                border: 1px dashed #eaecfa;
                margin-left: 20px;
            }
            .lk {
                display: flex;
                height: 40px;
                align-items: center;
                padding-left: 20px;
                padding-top: 20px;
                label {
                    width: 77px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    letter-spacing: 0px;
                }
                input {
                    width: 230px;
                    height: 40px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 16px;
                    padding-left: 10px;
                    font-size: 14px;
                    &::placeholder {
                        color: #999999;
                    }
                }
                textarea {
                    width: 332px;
                    height: 76px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 15px;
                    margin-top: 40px;
                    padding: 10px 0 0 8px;
                    font-size: 14px;
                }
            }

            .zhushi {
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #333333;
                padding: 27px 0 60px 40px;
            }
            .replay {
                display: flex;
                height: 44px;
                align-items: center;
                width: 100%;
                justify-content: center;
                padding-bottom: 60px;
                .left {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #3449d3;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-right: 50px;
                    cursor: pointer;
                }
                .right {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #6480ec;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
